<h3>Categoria chiave simmetrica</h3>
<h6>Regolamento</h6>
<p>
	Il crittosistema simmetrico che viene considerato è BunnyTN. Le specifiche 
	dell'algoritmo vengono rese disponibili sul sito internet dal 14 novembre.
	L'obbiettivo di ciascuna squadra è quello di trovare un attacco il più efficace e 
	veloce possibile a BunnyTN.
	Tutti i tipi di attacco e scenario sono i benvenuti.
	Alcuni esempi di attacchi che si possono trovare in letteratura sono i seguenti:
</p>
<ul>
	<li> Key-recovery attacks: attacchi che cercano di ricostruire la chiave segreta 
		dell'algoritmo (l'esempio più semplice è fare una ricerca esaustiva di tutte le 
		chiavi possibili).</li>
	<li> Distinguishing attacks: attacchi che cercano di distinguere informazioni cifrate 
		da messaggi random.</li>
</ul>
<p>
	A seconda del tipo di informazioni che l'attaccante possiede, si possono definire 
	diversi scenari: 
</p>
<ul>
	<li> Related-key attacks: l'attaccante può osservare il comportamento del crittosistema 
		con diverse chiavi segrete non note ma strettamente collegate da delle relazioni 
		matematiche (ad esempio i primi 80 bit delle chiavi sono sempre gli stessi)</li>
	<li> Chosen-plaintext attacks: l'attaccante ha la possibilità di scegliere dei messaggi 
		in chiaro e di conoscere il corrispettivo ciphertext.</li>
	<li> Known-plaintext/ciphertext attacks: l'attaccante ha a disposizione delle coppie 
		random di plaintext/ciphertext (ma che non può scegliere).</li>
	<li> Chosen-ciphertext attacks: l'attaccante ha la possibilità di scegliere dei 
		messaggi cifrati e di conoscere il corrispettivo plaintext.</li>
	</ul>
<h6>Punteggio</h6>
<p>
	Vengono premiati i migliori attacchi o tentativi di attacco sul crittosistema.
	A parità di strategia di attacco viene premiato quello che è riuscito a rompere 
	il maggior numero di round dell'algoritmo. 
</p>
<br>
<h6>Materiale</h6>
<ul>
	<li><a href="../../../../../../assets/attivita/cryptowars/2011/BunnyTN_Cipher.rar">
		SPECIFICHE DI BunnyTN (rar)</a></li>
	<li><a href="../../../../../../assets/attivita/cryptowars/2011/BunnyTN_Cipher.tar.gz">
		SPECIFICHE DI BunnyTN (tar.gz,zip)</a></li>
</ul>